
import { useEffect } from 'react';
import '@n8n/chat/style.css';
import { createChat } from '@n8n/chat';
import { ArrowRight, MessageCircle, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './AIChat.css';

const AIChat = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
		createChat({
	webhookUrl: 'https://n8n.indicrm.io/webhook/ab184a71-9eec-4e97-95dc-485286ff6c06/chat',
	webhookConfig: {
		method: 'POST',
		headers: {}
	},
	target: '#n8n-chat',
	mode: 'fullscreen',
	chatInputKey: 'chatInput',
	chatSessionKey: 'sessionId',
	loadPreviousSession: false,
	metadata: {},
	showWelcomeScreen: false,
	defaultLanguage: 'en',
	initialMessages: [
		'Hi',
		'I am Spark AI. How can I assist you today?'
	],
	i18n: {
		en: {
			title: 'Spark AI ⁺₊✧',
			subtitle: "Start a chat. We're here to help you 24/7.",
			footer: '',
			getStarted: 'New Conversation',
			inputPlaceholder: 'Type your question..',
		},
	},
	enableStreaming: false,
});
	}, []);

	return (<div>
      <header className="dashboard-header">
          <div className="header-content">
            <div className="logo-section">
              <div className="logo">
                <Sparkles className="logo-icon" />
              </div>
              <div className="brand">
                <h1 className="brand-title">Spark Accounts</h1>
                <p className="brand-subtitle">Smart Tally AI Agent</p>
              </div>
            </div>
            <nav className="nav-menu">
              <button 
                className="ai-chat-btn"
                onClick={() => navigate('/')}
              >
                <MessageCircle className="btn-icon" />
                Back to Dashboard
                <ArrowRight className="btn-arrow" />
              </button>
            </nav>
          </div>
        </header>
        <div id="n8n-chat"></div>
    </div>);
};

export default AIChat;

